<template>
  <div :class="classes">
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" :refresh="false" :current-page="currentPage" ref="table" isAddPageToRouter :isOutside="isOutside">
      <wt-table :list="tableData" :labels="tableLabel">
        <template slot="before">
          <el-table-column label="" width="120" fixed="left">
              <template slot-scope="scope">

                      <pt-img :class="$style['banner-picture']"
                      :src="$publicResourcesUrl+scope.row.imageUrl" styleName="mall-goods-banner-pictures"></pt-img>
              </template>
          </el-table-column>
        </template>
        <template>
          <slot/>
        </template>
      </wt-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-post-manage-table'

export default {
  name: 'pt-post-manage-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableLabel: {
      type: Array,
      default: function () {
        return []
      }
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 0
    },
    isOutside: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    },
    load () {
      this.$refs.table.load()
    },
    showReTry () {
      this.$refs.table.showReTry()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.banner-picture{
  width:100%;
}
</style>
